import React from 'react';
import { TAccessServiceType } from '../../@types/Access';
import AccessServiceIcon from '../common/AccessServiceIcon';
import './AccessServiceBadge.scss';

export interface IServiceIconProps {
  type: TAccessServiceType;
  iconOnly?: boolean;
}

const ServiceIcon = ({ type, iconOnly = false }: IServiceIconProps) => {
  const serviceValues = {
    audio_description: {
      label: 'Audio Description only',
    },
    audio_description_and_full_audio: {
      label: 'Audio Description + Full Audio',
    },
    closed_captions: {
      label: 'Closed Captioning',
    },
    amplified_audio: {
      label: 'Amplified Audio',
    },
    sign_language: {
      label: 'Sign Language',
    },
  };

  const targetService = serviceValues[type];

  if (iconOnly) {
    return (
      <div className="service-icon" aria-label={targetService.label}>
        <AccessServiceIcon serviceType={type} />
      </div>
    );
  } else {
    return (
      <div className="service-icon service-icon--yellow">
        <AccessServiceIcon serviceType={type} />{' '}
        <p className="service-icon__label">{targetService.label}</p>
      </div>
    );
  }
};

export default ServiceIcon;
